"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _schedulerNode = require("@/api/schedulerNode");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SchedulerNode',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      lastRefreshAt: null,
      query: {
        ip: '',
        applicationName: '',
        status: undefined
      },
      statusOptions: [{
        label: '在线',
        value: 1
      }, {
        label: '离线',
        value: 2
      }, {
        label: '已剔除',
        value: 3
      }],
      statusMap: {
        1: {
          label: '在线',
          tag: 'success'
        },
        2: {
          label: '离线',
          tag: 'warning'
        },
        3: {
          label: '已剔除',
          tag: 'danger'
        }
      }
    };
  },
  created: function created() {
    if (this.$store.getters.roles && this.$store.getters.roles.length) {
      this.getList();
    }
  },
  computed: {
    statusSummary: function statusSummary() {
      var summary = {
        total: this.total || 0,
        online: 0,
        offline: 0,
        blocked: 0
      };
      this.tableData.forEach(function (item) {
        if (item.status === 1) summary.online += 1;
        if (item.status === 2) summary.offline += 1;
        if (item.status === 3) summary.blocked += 1;
      });
      return summary;
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({
        page: this.page,
        limit: this.limit
      }, this.query);
      (0, _schedulerNode.fetchSchedulerNodes)(params).then(function (res) {
        _this.tableData = res && res.list || [];
        _this.total = res && res.total || 0;
        _this.lastRefreshAt = new Date();
        _this.tableData.forEach(function (item) {
          item.editableWeight = item.weight || 50;
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.query = {
        ip: '',
        applicationName: '',
        status: undefined
      };
      this.handleSearch();
    },
    handlePageChange: function handlePageChange(page) {
      this.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.limit = size;
      this.page = 1;
      this.getList();
    },
    handleBlock: function handleBlock(row) {
      var _this2 = this;
      this.$confirm("\u786E\u8BA4\u5C06\u8282\u70B9 ".concat(row.ip, " \u5254\u9664\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _schedulerNode.blockSchedulerNode)(row.id);
      }).then(function () {
        _this2.$message.success('节点已剔除');
        _this2.getList();
      });
    },
    handleEnable: function handleEnable(row) {
      var _this3 = this;
      (0, _schedulerNode.enableSchedulerNode)(row.id).then(function () {
        _this3.$message.success('节点已恢复');
        _this3.getList();
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u8282\u70B9\u8BB0\u5F55 ".concat(row.ip, " \u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _schedulerNode.deleteSchedulerNode)(row.id);
      }).then(function () {
        _this4.$message.success('删除成功');
        _this4.getList();
      });
    },
    getRowClassName: function getRowClassName(_ref) {
      var row = _ref.row;
      return row.status === 3 ? 'is-blocked-row' : '';
    },
    handleWeightChange: function handleWeightChange(row, value) {
      var _this5 = this;
      if (!row || value === row.weight) return;
      (0, _schedulerNode.updateSchedulerNodeWeight)(row.id, value).then(function () {
        row.weight = value;
        _this5.$message.success('权重已更新');
      }).catch(function () {
        row.editableWeight = row.weight || 50;
      });
    },
    formatDate: function formatDate(value) {
      if (!value) return '--';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      var pad = function pad(num) {
        return num < 10 ? "0".concat(num) : num;
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};